import { Price, Props } from '../BGH/price';

export const RegularPrice = (props: Props): JSX.Element => {
  return <Price {...props} />;
};
